import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'primereact/button';
import Container from 'react-bootstrap/Container';
import AllResourcesContent from './AllResourcesContent';

const InternalResources = () => {
	const navigate = useNavigate();

	return (
		<Container fluid="md" className="mt-2">
			<div className="flex align-items-center gap-2 mb-2">
				<Button link icon="pi pi-arrow-left" onClick={() => navigate(-1)} />
				<h4 className="m-0">Resources</h4>
			</div>
			<AllResourcesContent />
		</Container>
	);
};

export default InternalResources;
